// Handles the two-column Applications menu: keeps a selected app active and shows its contextual links pane.
// The exported initializer wires click/keyboard handlers for each app item and returns a cleanup function.
export function initAppsMenus(root: ShadowRoot): () => void {
  type Handler = { el: HTMLElement; onClick: (e: Event) => void; onKey: (e: KeyboardEvent) => void };
  const handlers: Handler[] = [];

  const menus = Array.from(root.querySelectorAll<HTMLElement>('.dropdown-menu.menu-apps'));

  menus.forEach((menu) => {
    const listItems = Array.from(menu.querySelectorAll<HTMLElement>('.apps-list .item-app'));
    const panes = Array.from(menu.querySelectorAll<HTMLElement>('.apps-sublinks .pane'));

    const setActive = (key: string | null) => {
      listItems.forEach((item) => item.classList.toggle('is-active', item.getAttribute('data-key') === key));
      panes.forEach((pane) => pane.classList.toggle('active', pane.getAttribute('data-key') === key));
    };

    // Default to the first app item if present.
    const firstKey = listItems[0]?.getAttribute('data-key') ?? null;
    if (firstKey) setActive(firstKey);

    listItems.forEach((item) => {
      const onClick = (e: Event) => {
        e.preventDefault();
        setActive(item.getAttribute('data-key'));
      };
      const onKey = (e: KeyboardEvent) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          setActive(item.getAttribute('data-key'));
        }
      };

      item.addEventListener('click', onClick);
      item.addEventListener('keydown', onKey);
      handlers.push({ el: item, onClick, onKey });
    });
  });

  return () => {
    handlers.forEach(({ el, onClick, onKey }) => {
      el.removeEventListener('click', onClick);
      el.removeEventListener('keydown', onKey);
    });
  };
}
